export const BookedActivitiesTabType = {
  History: 'History',
  Upcoming: 'Upcoming',
};

export type BookedActivitiesTab = (typeof BookedActivitiesTabType)[keyof typeof BookedActivitiesTabType];
